import ApiService from './api.service';

export const ModelEComplianceMetricService = {
  index(params) {
    return ApiService.query('model_e/compliance_metrics', {
      params,
    });
  },
  show(slug) {
    return ApiService.get('model_e/compliance_metrics', slug);
  },
  create(params) {
    return ApiService.post('model_e/compliance_metrics', { data: params });
  },
  update(slug, params) {
    return ApiService.update('model_e/compliance_metrics', slug, {
      data: params,
    });
  },
  destroy(slug) {
    return ApiService.delete('model_e/compliance_metrics', slug);
  },
};

export default ModelEComplianceMetricService;
